import { ComparatorService } from '../../../shared/services/comparator-service';
import { GbpublikationService } from '../../../core/gb-api/api/gbpublikation.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { Location, NgTemplateOutlet } from '@angular/common';
import { PublikationListEntry } from '../../../core/gb-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TableSortModel } from '../../../shared/tablesort/tableSortModel';
import { AbstractNavigateBackComponent } from '../../../shared/components/abstract-component/abstract-navigate-back.component';
import { catchError, map } from 'rxjs/operators';
import { ListLoaderObservable } from '../../../shared/components/list-loader/list-loader-observable';
import { EMPTY, Observable } from 'rxjs';
import { CapAlertLevel } from '../../../core/extension/exceptions/cap-alert-level.enum';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ListLoaderWrapperComponent } from '../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { ColumnHeaderComponent } from '../../../shared/tablesort/sort-icon/column-header.component';
import { KompaktGrundstueckComponent } from '../../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { KompaktGrundbuchgeschaeftComponent } from '../../../shared/kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.component';
import { PublikationListDetailComponent } from './publikation-list-detail/publikation-list-detail.component';
import { DatumPipe } from '../../../shared/pipes/simple/datum.pipe';
import { TranslateNamePipe } from '../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-publikation-list',
  templateUrl: './publikation-list.component.html',
  styleUrls: ['./publikation-list.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    CapSpinnerSmallComponent,
    ColumnHeaderComponent,
    KompaktGrundstueckComponent,
    KompaktGrundbuchgeschaeftComponent,
    PublikationListDetailComponent,
    TranslatePipe,
    DatumPipe,
    TranslateNamePipe
  ]
})
export class PublikationListComponent extends AbstractNavigateBackComponent implements OnInit {
  listLoader: ListLoaderObservable<PublikationListEntryVM>;
  tableSortModel = new TableSortModel<PublikationListEntryVM>('table', this.comparatorService);

  allExpanded = false;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected translate: TranslateService,
    private publikationService: GbpublikationService,
    protected location: Location,
    protected capAlertService: CapAlertService,
    protected comparatorService: ComparatorService
  ) {
    super(translate, capAlertService, location);
    keysToTranslate<string>(['Grundstück', 'Publikationsdatum', 'DatumEingabeFehler']);
    this.tableSortModel.addColumn('gemeinde', (a, b) =>
      this.comparatorService.gemeindeComparator(
        a.publikationListEntry.grundstueck.grundstueckNummer.gbGemeinde,
        b.publikationListEntry.grundstueck.grundstueckNummer.gbGemeinde
      )
    );
    this.tableSortModel
      .addColumn('grundstueck', (a, b) =>
        this.comparatorService.grundstueckComparator(a.publikationListEntry.grundstueck, b.publikationListEntry.grundstueck)
      )
      .switchSortDirection();
    this.tableSortModel.addColumn('publikationsdatum', (a, b) =>
      this.comparatorService.dateComparator(a.publikationListEntry.publikationsdatum, b.publikationListEntry.publikationsdatum)
    );
    this.tableSortModel.addColumn('geschaeftsNummer', (a, b) =>
      this.comparatorService.geschaeftComparator(
        a.publikationListEntry.grundbuchgeschaeft.timePoint,
        b.publikationListEntry.grundbuchgeschaeft.timePoint
      )
    );
  }

  public ngOnInit() {
    const request = JSON.parse(this.route.snapshot.queryParams['request']);
    const observable = this.publikationService.searchPublikation(request).pipe(
      map((response) => response.results.map((s) => new PublikationListEntryVM(s))),
      catchError((err) => this.handleError(err))
    );
    this.listLoader = new ListLoaderObservable(15, 1, observable);
    this.addLoaderAndNavigateBackIfEmpty(this.listLoader);
    this.listLoader.applySortModel(this.tableSortModel);
  }

  expandOrCollapse() {
    if (this.allExpanded) {
      this.collapseAllRows();
      this.allExpanded = false;
    } else {
      this.expandAllRows();
      this.allExpanded = true;
    }
  }

  private collapseAllRows() {
    this.listLoader.allItems.forEach((item) => (item.expanded = false));
  }

  private expandAllRows() {
    this.listLoader.allItems.forEach((item) => (item.expanded = true));
  }

  private handleError(err: any): Observable<any> {
    if (err.status === 400) {
      let alertText = '';
      for (const entry of err.error.results) {
        if (entry.messageKey === 'illegalDatumConstellation') {
          alertText += this.translate.instant('DatumEingabeFehler', { tage: 30 });
        } else {
          throw err;
        }
      }
      this.capAlertService.warning(alertText, CapAlertLevel.CONTENT_HEADER, true);
      this.location.back();
    } else {
      throw err;
    }
    return EMPTY;
  }
}

export class PublikationListEntryVM {
  hovered = false;
  expanded = false;

  constructor(public publikationListEntry: PublikationListEntry) {}
}
